import React, { useState } from 'react';
import '../CSS/Header.css';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

const AdminHeader: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isFromAdmin = searchParams.get('fromAdmin') === 'true';

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Get page name and directory path based on current route
  const getAdminBannerInfo = () => {
    const path = location.pathname;
    
    if (path === '/current-searches') {
      return {
        pageName: 'Current Searches',
        directoryPath: '/admin/job-directory'
      };
    } else if (path === '/news-and-insights/monthly-newsletter') {
      return {
        pageName: 'E-Newsletters',
        directoryPath: '/admin/monthly-news-directory'
      };
    } else if (path === '/news-and-insights/recent-placements') {
      return {
        pageName: 'Recent Placements',
        directoryPath: '/admin/placement-directory'
      };
    }
    
    return null;
  };

  const bannerInfo = getAdminBannerInfo();
  const showBanner = isFromAdmin && bannerInfo !== null;

  const handleLogout = () => {
    // Clear tokens from both localStorage and sessionStorage
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    sessionStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminUser');
    
    // Redirect to login page
    navigate('/admin-dashboard');
    closeMobileMenu();
  };

  const navigationItems = [
    'Job Details',
    'Placement News',
    'Monthly News',
    'Subscriber List'
  ];

  const getDirectPath = (item: string) => {
    switch (item) {
      case 'Job Details':
        return '/admin/job-directory';
      case 'Placement News':
        return '/admin/placement-directory';
      case 'Monthly News':
        return '/admin/monthly-news-directory';
      case 'Subscriber List':
        return '/admin/subscriber-directory';
      default:
        return null;
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <button 
            onClick={() => navigate('/')}
            className="logo-button"
            aria-label="Navigate to home"
          >
            <img 
              src="/assets/Web Version/myersmcrae-logo-light.svg" 
              alt="MyersMcRae Executive Search and Consulting" 
              className="logo-image"
            />
          </button>
        </div>
        
        <nav className="header-nav">
          {navigationItems.map((item) => {
            const directPath = getDirectPath(item);
            
            return (
              <div 
                key={item}
                className="nav-item"
              >
                  <button 
                    className="nav-link"
                  onClick={() => navigate(directPath || '/')}
                  >
                    {item}
                  </button>
              </div>
            );
          })}
        </nav>

        <div className="header-actions">
          <button 
            onClick={handleLogout}
            className="client-login-btn"
            style={{ 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer',
              fontFamily: 'inherit',
              fontSize: 'inherit',
              color: 'inherit',
              textDecoration: 'none'
            }}
          >
            Logout
          </button>
        </div>

        {/* Mobile Hamburger Button */}
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger-icon ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      {/* Mobile Menu - Extension of Header */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <nav className="mobile-nav">
            {navigationItems.map((item) => {
              const directPath = getDirectPath(item);
              
              return (
                <div key={item} className="mobile-nav-item">
                    <button
                      className="mobile-nav-link"
                      onClick={() => {
                        const path = directPath || '/';
                        navigate(path);
                        closeMobileMenu();
                      }}
                    >
                      {item}
                    </button>
                </div>
              );
            })}
          </nav>

          <div className="mobile-menu-footer">
            <button 
              onClick={handleLogout}
              className="mobile-client-login-btn"
              style={{ 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontSize: 'inherit',
                color: 'inherit',
                textDecoration: 'none',
                width: '100%',
                textAlign: 'center',
                padding: '1rem'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      )}

      {/* Admin Banner */}
      {showBanner && bannerInfo && (
        <div style={{
          backgroundColor: '#16416F',
          color: '#ffffff',
          padding: '1rem 2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontFamily: 'Lato, sans-serif',
          fontSize: '1rem',
          position: 'sticky',
          top: 0,
          zIndex: 1000
        }}>
          <span>You are viewing {bannerInfo.pageName} as an Admin.</span>
          <button
            onClick={() => navigate(bannerInfo.directoryPath)}
            style={{
              backgroundColor: '#ffffff',
              color: '#16416F',
              border: 'none',
              borderRadius: '6px',
              padding: '0.5rem 1.5rem',
              fontSize: '1rem',
              fontFamily: 'Lato, sans-serif',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'opacity 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1';
            }}
          >
            Return to Directory
          </button>
        </div>
      )}
    </header>
  );
};

export default AdminHeader;

